<template>
<v-container fluid pa-0>  
    <v-alert :value="true" type="success" dismissible v-model="alertSuccess">
        {{ resultMessage }}
    </v-alert>
    <v-alert :value="true" type="error" dismissible v-model="alertError">
        {{ resultMessage }}
    </v-alert>
    <v-card>
      <v-toolbar class="elevation-1">
        <v-toolbar-title>  
          Classes
        </v-toolbar-title>
        <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            flat
            v-model="search"
            solo
          ></v-text-field>
      </v-toolbar>
      <v-data-table
              :headers="headers"
              :items="items"
              item-key="RowId"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.course }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.teacher }}</td>
            <td disabled>
              <v-tooltip bottom>
                <v-btn slot="activator" fab v-bind:dark="!readonly" small color="red" outline  v-bind:disabled="readonly"
                  @click.stop="loadDialog(props.item.id, props.item.name)"
                  v-bind:value="props.item.id"
                ><v-icon dark>delete</v-icon>
                </v-btn>
                <span>Delete class</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.online">
                <v-btn slot="activator" fab v-bind:dark="!readonly" small color="green" outline ref="icon" v-bind:disabled="readonly"
                    @click.stop="makeOnline(props.item, false)"
                    v-bind:value="props.item.id"
                ><v-icon dark>remove_red_eye</v-icon>
                </v-btn>
                <span>Hide class</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!props.item.online">
                <v-btn slot="activator" fab dark small color="grey" outline ref="icon"
                    @click.stop="makeOnline(props.item, true)"
                    v-bind:value="props.item.id"
                ><v-icon dark>remove_red_eye</v-icon>
                </v-btn>
                <span>Show class</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" fab dark small color="grey" outline 
                  :to="{ name: 'StudentClasses', params: { classId: props.item.id, className: props.item.name, classCode: props.item.code }}">
                  <v-icon dark>people</v-icon>
                </v-btn>
                <span>Inspect students</span>
              </v-tooltip>
               <v-tooltip bottom>
                <v-btn slot="activator" fab v-bind:dark="!readonly" small color="orange" outline v-bind:disabled="readonly"
                  :to="{ name: 'TeacherClasses', params: { classId: props.item.id, className: props.item.name, classCode: props.item.code }}">
                  <v-icon dark>supervisor_account</v-icon>
                </v-btn>
                <span>Manage teachers</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>    
    </v-card>
    <v-dialog v-model="dialog" max-width="35%">
      <v-card>
          <v-card-title>
              Confirmation
          </v-card-title>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        This action will remove all the info related to the class &nbsp;  
                        <b>  {{ selectedClass }}  &nbsp; </b> 
                        from the period &nbsp; <b>{{ periodName }}</b>
                    </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="deleteClass()">Delete</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="dialogManageTeachers" max-width="35%">
      <v-card>
          <v-card-title>
              Manage Teachers for Class {{ selectedClass }}
          </v-card-title>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        This action will remove all the info related to the class &nbsp;  
                        <b>  {{ selectedClass }}  &nbsp; </b> 
                        from the period &nbsp; <b>{{ periodName }}</b>
                    </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="unloadManageTeachers()">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="saveTeachers()">Save</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>
<script>
  import { getListByPeriod, deleteClassFromPeriod } from '../utils/effort-tracking-api'
  import { makeClassOnline } from '../utils/effort-tracking-api'
  import { globalStore } from '../main'

  export default {
    data () {
      return {
        search: '',
        loading: true,
        totalItems: 0,
        rowsPerPageItems: globalStore.rowsPerPageItems,
        pagination: { sortBy: 'code', rowsPerPage: globalStore.defaultRowsPerPage },
        dialog: false,
        dialogManageTeachers: false,
        periodName: '',
        selectedClass: '',
        selectedClassId: 0,
        alertSuccess: false,
        alertError: false,
        resultMessage: '',
        readonly: false,
        headers: [
          { text: 'Code', value: 'code' },
          { text: 'Course', value: 'course' },
          { text: 'Name', value: 'name' },
          { text: 'Teacher', value: 'teacher' },
          { text: 'Actions', value: '', sortable: false }
        ],
        items: []
      }
    },
     watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
            this.debouncedGetDataFromApi()
        },
        deep: true
      }
    },
    mounted () {
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true }),
      this.setPeriodName();
      this.disableActions();
    },
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
          this.loading = true;
          getListByPeriod("classes", this.pagination, this.search).then(data => {
            console.log(data.items);
            this.items = data.items
            this.totalItems = data.count
            this.loading = false;
        })
        this.disableActions();
      },
      unloadDialog() {
        this.dialog = false;
        this.selectedClassId = 0;
        this.selectedClass = '';
      },
      loadDialog(classId, className) {
        this.alertSuccess = false;
        this.alertError = false;
        this.dialog = true;
        this.selectedClass = className;
        this.selectedClassId = classId;
      },
      unloadManageTeachers(){
        this.dialogManageTeachers = false;
        this.selectedClassId = 0;
        this.selectedClass = '';
      },
      setPeriodName() {
        var periodId = localStorage.getItem('period-selected');
        var period = this.$store.state.periods.filter(p => p.id == Number(periodId));
        this.periodName = ((period.length > 0) ? period[0].text : '');
      },
      deleteClass() {
        var periodId = localStorage.getItem('period-selected');
        deleteClassFromPeriod(this.selectedClassId, periodId).then(result => {
          this.dialog = false;
          this.selectedClass = '',
          this.selectedClassId = 0;
          this.resultMessage = result.data.message;
          if(result.data.success) {
            this.alertSuccess = true;
          } else {
            this.alertError = true;
          }

          this.getDataFromApi();
         
        });
      },

      saveTeachers() {
        console.log('Saving teachers for class...');
        // var periodId = localStorage.getItem('period-selected');
        // deleteClassFromPeriod(this.selectedClassId, periodId).then(result => {
        //   this.dialog = false;
        //   this.selectedClass = '',
        //   this.selectedClassId = 0;
        //   this.resultMessage = result.data.message;
        //   if(result.data.success) {
        //     this.alertSuccess = true;
        //   } else {
        //     this.alertError = true;
        //   }

        //   this.getDataFromApi();
         
        // });
      },

      disableActions() {       
        var periodId = localStorage.getItem('period-selected');
        var p = this.$store.state.periods.filter( p => Number(p.id) == periodId);
        this.readonly = ((p.length > 0 )? p[0].complete : false);
      },

      makeOnline(_class, online) {
        console.log(_class);
        console.log(online);
        var periodId = localStorage.getItem('period-selected');
        makeClassOnline(_class.id, periodId, online)
        .then(result => { 
              console.log(result);
              this.debouncedGetDataFromApi();
          })
        .catch(ex => console.log(ex));
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Classes.vue